import { createRouter, createWebHistory } from 'vue-router'
import { reactive } from 'vue'
import emitFlowState from '@/utils/custom-events/customEventsEmit'
import { trackUxtweakPageView } from '@/utils/uxtweak'
import { updatePageTitle } from './utils'
import { validateUserTokenAndAuthorities } from './guards'
import routes from './routes'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
export const lastRoute = reactive({ value: null })

// Router navigation hooks
router.beforeEach((to, from, next) => {
// router.beforeEach(to => {
  lastRoute.value = from && from.name ? from : null

  updatePageTitle(to)
  if (to.name) emitFlowState(to.name, 'start')
  validateUserTokenAndAuthorities(to, from, next)
})

// UXtweak Session Recording spike (MANCRE-5570) — afterEach only fires on confirmed navigations
router.afterEach(to => trackUxtweakPageView(to))

export default router
